import { Type } from "@scalar/typebox";
const AppearanceSchema = Type.Partial(
  Type.Object({
    layout: Type.Union([Type.Literal("modern"), Type.Literal("classic")]),
    theme: Type.String(),
    favicon: Type.String(),
    initialColorMode: Type.Union([Type.Literal("auto"), Type.Literal("dark"), Type.Literal("light")]),
    forceColorMode: Type.Union([Type.Literal("dark"), Type.Literal("light")]),
    css: Type.String(),
    loadDefaultFonts: Type.Boolean()
  })
);
const defaultAppearance = {
  layout: "modern",
  theme: "default",
  favicon: "",
  initialColorMode: "auto",
  forceColorMode: "dark",
  css: "",
  loadDefaultFonts: true
};
export {
  AppearanceSchema,
  defaultAppearance
};
//# sourceMappingURL=appearance.js.map
